import { Component, Input, OnInit } from '@angular/core';
import { IPropertyUnitGroupSpaces } from '../../../core/interfaces/property';

enum SpacesOrder {
  SquareFootage = 'square-meter',
  Rooms = 'room',
  KingBed = 'king',
  QueenBed = 'queen',
  MiscBed = 'beds',
  DoubleBed = 'double',
  SingleBed = 'single',
  Daybed = 'daybed',
  SofaBed = 'sofa',
  Balcony = 'balcony',
  Terrace = 'terrace'
}

@Component({
  selector: 'app-suite-info-spaces',
  templateUrl: './suite-info-spaces.component.html',
  styleUrls: ['./suite-info-spaces.component.scss'],
  standalone: false
})
export class SuiteInfoSpacesComponent implements OnInit {
  @Input() additionalClass: string;
  @Input() spaces: IPropertyUnitGroupSpaces[] = [];
  orderedSpaces: IPropertyUnitGroupSpaces[] = [];

  constructor() {}

  ngOnInit(): void {
    const workingArray = [];
    const spacesOrderValues = Object.values(SpacesOrder) as string[];

    spacesOrderValues.forEach((value) =>
      workingArray.push(
        this.spaces
          ?.filter((space) => space.slug.includes(value))
          .sort((a, b) => {
            const aName = a.name.toLowerCase();
            const bName = b.name.toLowerCase();

            if (aName < bName) {
              return 1;
            }

            if (aName == bName) {
              return 0;
            }

            if (aName > bName) {
              return -1;
            }
          })
      )
    );

    workingArray.push(
      this.spaces?.filter((space) => !spacesOrderValues.some((element) => space.slug.includes(element)))
    );

    this.orderedSpaces = workingArray.flat();
  }
}
